import { MassMessageRecepientValueType } from 'models';

import CheckIcon from '@material-ui/icons/Check';
import RemoveIcon from '@material-ui/icons/Remove';

import clsx from 'clsx';
import { memo } from 'react';
import { useStyles } from './style';

interface Props {
  name?: string;
  disabled?: boolean;
  status: MassMessageRecepientValueType;
  handleChangeStatus?: (
    status: MassMessageRecepientValueType,
    name?: string
  ) => void;
}

const MassMessageCheckbox: React.FC<Props> = ({
  status = 'default',
  disabled,
  handleChangeStatus,
  name,
}) => {
  const classes = useStyles();

  const handleClick = (name?: string) => {
    if (handleChangeStatus) {
      const newStatus: MassMessageRecepientValueType =
        status === 'default'
          ? 'apply'
          : status === 'apply'
          ? 'reject'
          : status === 'reject'
          ? 'default'
          : status;

      handleChangeStatus(newStatus, name);
    }
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.apply]: status === 'apply',
        [classes.reject]: status === 'reject',
        [classes.disabled]: disabled,
      })}
      onClick={disabled ? undefined : () => handleClick(name)}
    >
      {status === 'apply' ? <CheckIcon className={classes.icon} /> : null}
      {status === 'reject' ? <RemoveIcon className={classes.icon} /> : null}
    </div>
  );
};

export default memo(MassMessageCheckbox);
